// extracted by mini-css-extract-plugin
export default {"container":"GameEditor_container__l2sZ4","loadingOverlay":"GameEditor_loadingOverlay__gSRMb","loadingPercentage":"GameEditor_loadingPercentage__0PRk0"};